
export default function approval( state = [], action = {} ){

	switch( action.type ){
		case 'GET_LEAVE_APPROVALS':
			return action.approval
		case 'SET_LEAVE_APPROVALS':
			return action.approval
		case 'GET_LEAVE_TYPE_APPROVALS':
			return action.approval
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/approvals/approvals.reducer.js